import { Box, Button, Grid, Typography } from '@mui/material';
import FormsPopup from '../../common/FormsPopup/FormsPopup';
import UserAvatar from '../../common/UserAvatar/UserAvatar';
import { MyProfileProps } from './types';
import styles from './styles';

const MyProfileDetails = ({
    openProfileDetails,
    setOpenProfileDetails,
    setEditProfileDetails,
    userData,
}: MyProfileProps) => {
    return (
        <FormsPopup
            id="profile_details"
            open={openProfileDetails}
            title="My Profile"
            textAlign="left"
            handleClose={() => setOpenProfileDetails(false)}
            width={662}
        >
            <Box component="form" noValidate>
                <Grid container spacing={2} sx={styles.container}>
                    <Grid item xs={6}>
                        <UserAvatar
                            name={`${userData.firstname} ${userData.lastname}`}
                            source={
                                userData.signedImageUrl &&
                                userData.signedImageUrl !== 'null' &&
                                userData.signedImageUrl !== 'undefined'
                                    ? userData.signedImageUrl
                                    : ''
                            }
                            size={279}
                            radius="16px"
                            fontSize={50}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <Typography sx={styles.profileLable}>Complete Name</Typography>

                        <Typography sx={styles.profileValue}>{userData.name}</Typography>

                        <Typography sx={styles.profileLable}>Role</Typography>

                        <Typography sx={styles.profileValue}>{userData.roleName}</Typography>

                        <Typography sx={styles.profileLable}>Email</Typography>

                        <Typography sx={styles.profileValue}>{userData.email}</Typography>
                    </Grid>
                    <Button
                        variant="contained"
                        sx={styles.profileButton}
                        onClick={() => {
                            setEditProfileDetails(true);
                        }}
                        id="editMyProfile"
                        data-testid="editMyProfile"
                    >
                        Edit My Profile
                    </Button>
                </Grid>
            </Box>
        </FormsPopup>
    );
};
export default MyProfileDetails;
